import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import MainView from '@/views/layout/Main.vue'
import {MENU, SUBMENU} from "@/defs/menu.js";

import LinkView from "@/views/event/Link.vue";

Vue.use(Router)

const routes = {
  mode: 'history',
  routes: [
    {
      path: '/',
      component: MainView,
      beforeEnter: (to, from, next) => {
        store.commit('store/setPreviewDate', _.has(to.query, 'date') ? to.query.date : '')
        next();
      },
      children : [
        MENU.HOME,
        MENU.SCHEDULE,
        MENU.CHANNEL,
        MENU.NOTICE,
        SUBMENU.LOCATION,
        SUBMENU.ADVERTISE,
        SUBMENU.CONTACT,
        { path: "/event", component: LinkView},
      ]
    },
    { path: "*", redirect:"/"}
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
};

export const router = new Router(routes);

// router.beforeEach(async (to, from, next) => {
//   console.log(`from : ${from.path}`);
//   console.log(`to : ${to.path}`);
//   next();
// });


// SEO 설정 (페이지 전환 시 META TAG 변경)
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

router.afterEach(() => {});
